import { ref, watch } from 'vue'

const STORAGE_KEY = 'timurka-sessions'

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return []
}

function save(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

const sessions = ref(load())

watch(sessions, (val) => save(val), { deep: true })

export function useSessionStats() {
  function startSession(type, meta) {
    return {
      id: Date.now(),
      type,
      meta: meta || {},
      startedAt: Date.now(),
      endedAt: null,
      duration: 0,
      total: 0,
      correct: 0,
      wrong: 0,
      avgTime: 0,
      level: 1,
    }
  }

  function endSession(session) {
    session.endedAt = Date.now()
    session.duration = Math.round((session.endedAt - session.startedAt) / 1000)
    sessions.value.push({ ...session })
  }

  function getRecent(days) {
    const cutoff = Date.now() - days * 24 * 60 * 60 * 1000
    return sessions.value.filter(s => s.startedAt > cutoff)
  }

  function getByDay(days) {
    const recent = getRecent(days)
    const map = {}
    for (const s of recent) {
      const d = new Date(s.startedAt)
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
      if (!map[key]) map[key] = { date: key, sessions: 0, total: 0, correct: 0, duration: 0 }
      map[key].sessions++
      map[key].total += s.total
      map[key].correct += s.correct
      map[key].duration += s.duration
    }
    const result = []
    for (let i = days - 1; i >= 0; i--) {
      const d = new Date(Date.now() - i * 24 * 60 * 60 * 1000)
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
      const entry = map[key] || { date: key, sessions: 0, total: 0, correct: 0, duration: 0 }
      result.push(entry)
    }
    return result
  }

  function resetSessions() {
    sessions.value = []
  }

  return {
    sessions,
    startSession,
    endSession,
    getRecent,
    getByDay,
    resetSessions,
  }
}
